import React from 'react'
import { Route, IndexRoute } from 'react-router'

import Media from '../components/media/list'
import CreateMedia from '../components/media/create'
import EditMedia from '../components/media/edit'

const CmsRoutes = (
  <Route path='media'>
    <IndexRoute component={Media} />
    <Route path='create' component={CreateMedia} />
    <Route path=':mediaId/edit' component={EditMedia} />
  </Route>
)

export default CmsRoutes
